export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  date: string;
  cover: string;
  content: string[];
  relatedWorkId?: string;
}

export const news: NewsItem[] = [
  {
    id: "haruka-harbor-opening",
    title: "《海边的信》正式公映，希岛爱理挑战沉默型角色获好评",
    summary:
      "由中村悠介执导的电影《海边的信》正式公映。希岛爱理在片中饰演安静而执拗的少女真纪，以大量无台词表演收获观众好评。",
    date: "2023-09-18",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20quiet%20seaside%20town%20at%20dusk%2C%20long%20shoreline%2C%20muted%20deep%20blue%20and%20warm%20amber%20light%2C%20editorial%20film%20still%2C%20soft%20grain&width=1200&height=800&seq=news-harbor&orientation=landscape",
    content: [
      "由中村悠介执导的电影《海边的信》于本月正式登陆院线。影片讲述海边小镇少女真纪因一封寄错的信，重新面对家庭往事的故事。",
      "希岛爱理在片中饰演的真纪台词极少，大量情绪依靠眼神与细微的肢体动作传达。导演中村悠介在采访中表示，正是这种“几乎静止”的表演方式，让整部电影拥有了呼吸感。",
      "影片上映后，不少观众在社交平台分享观影感受，认为真纪与母亲之间那场没有配乐的对白戏，是全片最克制也最有力量的段落。",
    ],
    relatedWorkId: "harbor-letters",
  },
  {
    id: "silent-confession-teaser",
    title: "《无声告白》释出全新预告，手语题材引发关注",
    summary:
      "电视剧《无声告白》公布最新预告片，希岛爱理饰演的手语翻译琴音在预告中展现细腻演技，题材聚焦沟通与沉默。",
    date: "2024-03-28",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20moody%20deep%20blue%20and%20amber%2C%20editorial%20film%20still&width=1200&height=800&seq=news-silent&orientation=landscape",
    content: [
      "即将播出的电视剧《无声告白》日前发布最新预告片。该剧以手语翻译员琴音的视角展开，讲述她在案件翻译过程中察觉异常、追寻真相的故事。",
      "预告片中，希岛爱理以一袭深色外套出镜，在审讯室的对手戏里仅凭一个停顿的眼神便传递出巨大信息量，被网友称为“教科书级别的细节表演”。",
      "制作方表示，剧组在拍摄前邀请了专业手语顾问全程指导，力求让每一次手语的呈现都准确而富有情绪。",
    ],
    relatedWorkId: "silent-confession",
  },
  {
    id: "winter-echo-award",
    title: "《冬日回声》入围年度剧集评选，希岛爱理获最佳女主角提名",
    summary:
      "年末剧集评选中，《冬日回声》入围多个奖项，希岛爱理凭借店主理纱一角获得最佳女主角提名。",
    date: "2023-01-10",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20snowy%20northern%20town%20with%20warm%20window%20lights%2C%20cozy%20record%20store%2C%20winter%20atmosphere%2C%20editorial%20film%20still&width=1200&height=800&seq=news-winter&orientation=landscape",
    content: [
      "年度剧集评选公布入围名单，治愈系剧集《冬日回声》入围最佳剧集、最佳编剧等多个奖项。",
      "希岛爱理在剧中饰演旧唱片店店主理纱，以克制的表演刻画了一个独居女性在寒冬中被一通深夜来电搅动心绪的全过程，获得最佳女主角提名。",
      "评委会评价称，理纱这个角色“没有大起大落，却让人记住了每一次沉默的重量”。",
    ],
    relatedWorkId: "winter-echo",
  },
  {
    id: "starlight-promise-wrap",
    title: "《星光下的约定》杀青，希岛爱理分享拍摄幕后",
    summary:
      "电影《星光下的约定》宣布杀青。希岛爱理在片中饰演天文台实习生遥，并分享了夜戏拍摄的幕后故事。",
    date: "2024-08-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20hilltop%20under%20a%20starry%20night%20sky%2C%20telescope%20silhouette%2C%20deep%20navy%20and%20warm%20star%20light%2C%20editorial%20film%20still&width=1200&height=800&seq=news-starlight&orientation=landscape",
    content: [
      "历经两个月拍摄，电影《星光下的约定》正式杀青。影片讲述天文台实习生遥与作曲家在山顶星空下许下重逢约定的故事。",
      "希岛爱理在分享中透露，为了呈现真实的观星状态，她提前学习了天文望远镜的使用，并与剧组一起在山顶守候了多个晴朗的夜晚。",
      "“有一场戏拍到凌晨三点，整个山头只剩下风声，那种安静反而让人更容易进入角色。”她在采访中说。",
    ],
    relatedWorkId: "starlight-promise",
  },
  {
    id: "kyoto-summer-reunion",
    title: "《京都之夏》特别放映会举行，主创重聚分享夏日回忆",
    summary:
      "上映两周年之际，《京都之夏》举办特别放映会，希岛爱理与导演小林悠真出席，与观众分享拍摄期间的夏日记忆。",
    date: "2023-07-23",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20traditional%20Kyoto%20alley%20with%20summer%20lanterns%20at%20dusk%2C%20warm%20green%20and%20amber%20light%2C%20editorial%20film%20still&width=1200&height=800&seq=news-kyoto&orientation=landscape",
    content: [
      "电影《京都之夏》迎来上映两周年，特别放映会邀请主创与影迷共同重温这个发生在京都的夏日故事。",
      "希岛爱理回忆起当时顶着高温拍摄祭典戏的经历，笑称“汗水也是表演的一部分”。她表示，纱织这个角色让她重新思考了“做选择”这件事的意义。",
      "导演小林悠真则分享了町屋取景的幕后，称希望用最日常的空间承载最浓的情绪。",
    ],
    relatedWorkId: "kyoto-summer",
  },
  {
    id: "city-lights-radio",
    title: "《城市之光》剧照公开，深夜电台设定引共鸣",
    summary:
      "电视剧《城市之光》公开一组剧照，希岛爱理饰演的深夜电台主播凛在暗色直播间中的画面引发都市观众共鸣。",
    date: "2023-02-05",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20dim%20radio%20studio%20at%20night%20with%20a%20microphone%20and%20city%20lights%20outside%2C%20deep%20blue%20and%20warm%20orange%20accent%2C%20editorial%20film%20still&width=1200&height=800&seq=news-city&orientation=landscape",
    content: [
      "《城市之光》日前公布一组剧照，展现深夜电台主播凛工作的直播间场景。暗蓝的灯光与窗外城市夜色形成鲜明对比。",
      "希岛爱理饰演的凛，用声音陪伴无数陌生人度过漫漫长夜。她表示，这个角色最打动她的地方在于“她接住别人，却很少允许自己被接住”。",
      "不少观众表示，看完剧集后开始重新留意深夜里那些仍在亮着的窗口。",
    ],
    relatedWorkId: "city-lights",
  },
  {
    id: "chasing-wind-score",
    title: "《追风的少女》原声带上线，主题曲传递向前力量",
    summary:
      "电影《追风的少女》原声带正式上线，主题曲以明亮的旋律呼应片中少女沿海骑行的旅程。",
    date: "2022-07-01",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20a%20coastal%20road%20at%20golden%20hour%20with%20a%20bicycle%20shadow%2C%20warm%20amber%20and%20teal%20sea%2C%20editorial%20film%20still&width=1200&height=800&seq=news-chasing&orientation=landscape",
    content: [
      "电影《追风的少女》原声带正式发布，收录多首原创配乐及主题曲。",
      "整张原声带围绕“向前”的情绪展开，主题曲以逐渐明亮的编曲呼应女主角向日葵沿海骑行的旅途。",
      "希岛爱理在采访中表示，每次听到主题曲都会想起拍摄时海风扑面而来的感觉。",
    ],
    relatedWorkId: "chasing-wind",
  },
  {
    id: "tender-lies-retro",
    title: "《温柔的谎言》回看专题：家庭叙事中的克制与爆发",
    summary:
      "经典剧集《温柔的谎言》推出回看专题，解析希岛爱理饰演的美咲在家庭谎言中的挣扎与成长。",
    date: "2024-05-20",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20press%20photo%20of%20an%20elegant%20warm%20apartment%20dining%20room%20with%20soft%20lamp%20light%2C%20amber%20and%20deep%20teal%20tones%2C%20family%20drama%20editorial%20film%20still&width=1200&height=800&seq=news-tender&orientation=landscape",
    content: [
      "剧集《温柔的谎言》播出多年后仍常被讨论，平台近日推出回看专题，重新解析这部聚焦家庭关系的作品。",
      "希岛爱理饰演的美咲夹在母亲与祖母之间，以善意的谎言维系家庭体面，却也被谎言反复灼伤。专题特别分析了家庭聚餐那场真相爆发的戏。",
      "评论认为，该剧难得地让“谎言”与“温柔”同时成立，也让美咲成为最接地气的角色之一。",
    ],
    relatedWorkId: "tender-lies",
  },
];

export function getNewsById(id: string): NewsItem | undefined {
  return news.find((n) => n.id === id);
}